import DOMPurify from 'dompurify'

/* @ngInject */
function SocialMediaController ($rootScope, $scope, $q, $state, $location, $translate, $timeout, $stateParams, TemplateService, UdsModalService, SocialMediaService, ToastService, Utils) {
  const getSocialMediaPreviewDialogController = () => $q.when(import('../../dialogs/social-media-preview/social-media-preview.controller'))
  const getSocialMediaLinkedController = () => $q.when(import('../../dialogs/social-media-linked/social-media-linked.controller'))

  let hasCompanyCaptionValue = false
  let isInitialLoad = true

  $rootScope.isSecondLevelSidebarExpanded = false

  $scope.flags = {
    loading: false,
    emptyAccount: false,
    showWarningSize: false
  }

  $scope.formProperties = {
    account: null,
    format: 'FEED',
    caption: '',
    gateway: null,
    materials: [],
    selectedIndex: 0
  }

  $scope.validationState = {
    canContinue: true,
    hasErrors: false
  }

  $scope.artPreviewUrl = null
  $scope.accountsList = []
  $scope.template = null

  const api = {
    getSocialMediaPreviewDialogController,
    getSocialMediaLinkedController,
    _backToArtsPage,
    _getArtInfo,
    _showDefaultError,
    _createAccountsList,
    _checkSocialMediaIntegrationStatus,
    _openSocialMediaLinked,
    _isAbleToPublish,
    _stripRichText,
    _checkAssetSize,
    _richTextToPlainText,
    _validateMaterials,
    _handleCaptionOnAddImages,
    _getMaterialCaption,
    _setCaptionFromMaterial,
    _getTemplatesDetailsForPreview
  }
  this.getApi = () => api

  activate()
  function activate () {
    const templateIds = $stateParams.templateIds

    if (!templateIds) {
      return api._backToArtsPage()
    }

    const deregisterAddImages = $scope.$on('imageCarousel:addImages', (event, newImages) => {
      if (newImages && newImages.length > 0) {
        const existingIds = $scope.formProperties.materials.map(material => material.id)
        const uniqueNewImages = newImages.filter(image => !existingIds.includes(image.id))

        if (uniqueNewImages.length > 0) {
          $scope.formProperties.materials = [...$scope.formProperties.materials, ...uniqueNewImages]
          api._validateMaterials()
          api._handleCaptionOnAddImages(uniqueNewImages)
        }
      }
    })

    const deregisterRemoveImage = $scope.$on('imageCarousel:removeImage', (event, data) => {
      if (data && data.materials) {
        $scope.formProperties.materials = data.materials

        if (data.selectedIndex !== undefined) {
          $scope.formProperties.selectedIndex = data.selectedIndex
        }

        api._validateMaterials()
      }
    })

    const deregisterReorder = $scope.$on('imageCarousel:reorder', (event, data) => {
      if (data && data.materials) {
        $scope.formProperties.materials = data.materials

        if (data.selectedIndex !== undefined) {
          $scope.formProperties.selectedIndex = data.selectedIndex
        }

        api._validateMaterials()
      }
    })

    const deregisterValidationChanged = $scope.$on('imageCarousel:validationChanged', (event, data) => {
      $scope.validationState.canContinue = data.canContinue
      $scope.validationState.hasErrors = data.hasErrors
    })

    const deregisterMaterialsUpdated = $scope.$on('imageCarousel:materialsUpdated', (event, data) => {
      if (data?.materials) {
        $scope.formProperties.materials = data.materials
        api._validateMaterials()

        if (!isInitialLoad && data.hasMultiPageMaterial && data.materials.length > 0) {
          api._setCaptionFromMaterial(data.materials[0])
        }
      }
    })

    const deregisterSelectionChanged = $scope.$on('imageCarousel:selectionChanged', (event, data) => {
      if (data?.selectedIndex !== undefined) {
        $scope.formProperties.selectedIndex = data.selectedIndex
      }
    })

    $scope.$on('$destroy', () => {
      deregisterAddImages()
      deregisterRemoveImage()
      deregisterReorder()
      deregisterValidationChanged()
      deregisterMaterialsUpdated()
      deregisterSelectionChanged()
    })

    api._getArtInfo(templateIds)
    api._checkSocialMediaIntegrationStatus()
  }

  $scope.onSelectFormat = (event) => {
    const type = event.detail.value
    $scope.formProperties.format = type
  }

  $scope.backToArtsPage = api._backToArtsPage

  $scope.openPostPreview = () => {
    $scope.flags.emptyAccount = false

    const socialType = 'instagram'
    const imageUrl = $scope.artPreviewUrl
    const publishType = $scope.formProperties.format
    const accountId = $scope.formProperties.account?.id
    const artId = parseInt($stateParams.templateId, 10)
    const mediaType = 'IMAGE'
    const caption = $scope.formProperties.caption || ''

    const hasNotSelectedAccount = !accountId

    if (hasNotSelectedAccount) {
      $scope.flags.emptyAccount = true
      return
    }

    api.getSocialMediaPreviewDialogController().then(({ SocialMediaPreviewController }) => {
      const socialMediaPreviewDialog = UdsModalService.createModal({
        controller: SocialMediaPreviewController,
        modalName: 'socialMediaPreviewDialog',
        data: {
          socialType,
          imageUrl,
          publishType,
          accountId,
          caption,
          artId,
          mediaType,
          materials: $scope.formProperties.materials,
          selectedIndex: $scope.formProperties.selectedIndex
        }
      })

      socialMediaPreviewDialog.open()
    })
  }

  $scope.handleAccountChange = (event) => {
    const value = event.detail

    $scope.formProperties.account = value
  }

  $scope.handleCaptionChange = (event) => {
    const value = event.detail.value
    const valueLength = value?.length

    if (!valueLength) {
      hasCompanyCaptionValue = false
    }

    $scope.formProperties.caption = value
  }

  $scope.getCaptionHelper = () => {
    if (hasCompanyCaptionValue) {
      const company = $rootScope.oUserCompany.formattedName

      return $translate.instant('socialMedia.captionHelper', {
        company
      })
    }

    return null
  }

  $scope.getSelectedMaterial = () => {
    if ($scope.formProperties.materials && $scope.formProperties.materials.length > 0) {
      const index = $scope.formProperties.selectedIndex || 0
      return $scope.formProperties.materials[index] || $scope.formProperties.materials[0]
    }
    return null
  }

  function _backToArtsPage () {
    $state.go('user.arts')
  }

  async function _getArtInfo (templateIds) {
    $scope.flags.loading = true

    try {
      const isUser = $rootScope.isUser()
      const isEnableSocialMedia = $rootScope.isEnableSocialMedia
      const searchBy = 'user'

      const params = {
        searchBy
      }

      const socialType = 'instagram'
      const templatesResponse = await api._getTemplatesDetailsForPreview(templateIds)

      const artIds = templateIds
      const previewUrl = await SocialMediaService.getContentToPublish(socialType, artIds)
      const gatewayResponse = await $rootScope.getSocialMediaGateway()
      const accounts = await SocialMediaService.getAccounts(socialType, params)

      const isNotAbleToPublish = !api._isAbleToPublish(templatesResponse, isUser, isEnableSocialMedia)

      if (isNotAbleToPublish) {
        return $state.go('user.arts')
      }

      $timeout(() => {
        if (typeof previewUrl === 'string') {
          $scope.artPreviewUrl = previewUrl
        } else if (Array.isArray(previewUrl)) {
          $scope.artPreviewUrl = previewUrl[0]?.signedUrl || previewUrl[0]?.url || previewUrl[0] || previewUrl
        } else if (previewUrl && (previewUrl.signedUrl || previewUrl.url)) {
          $scope.artPreviewUrl = previewUrl.signedUrl || previewUrl.url
        } else {
          $scope.artPreviewUrl = previewUrl
        }
        $scope.accountsList = api._createAccountsList(accounts.rows)
        $scope.template = templatesResponse[0]
        $scope.formProperties.gateway = gatewayResponse

        $scope.formProperties.materials = templatesResponse.map((material, index) => {
          const previewContent = Array.isArray(previewUrl) ? previewUrl[index] : previewUrl
          return {
            ...material,
            artId: material.artId || material.id,
            layerId: material.layerId,
            url: previewContent?.signedUrl || material.url || material.thumbnailUrl || material.previewUrl || $scope.artPreviewUrl,
            thumbnail: previewContent?.signedUrl || material.thumbnail || material.thumbnailUrl || material.previewUrl || $scope.artPreviewUrl
          }
        })
        $scope.formProperties.selectedIndex = 0

        const caption = templatesResponse[0]?.details?.suggestions || ''

        $scope.formProperties.caption = api._richTextToPlainText(caption)
        hasCompanyCaptionValue = !!caption.length
        api._checkAssetSize(templatesResponse)
        isInitialLoad = false
      })
    } catch (error) {
      api._showDefaultError(error)
    } finally {
      $timeout(() => {
        $scope.flags.loading = false
      })
    }
  }

  function _getTemplatesDetailsForPreview (templateIds) {
    const promises = templateIds.map(templateId => TemplateService.getTemplateDetailsForPreview(templateId))
    return Promise.all(promises)
  }

  function _richTextToPlainText (html) {
    if (!html) return ''

    return html
      .replace(/&nbsp;/gi, ' ')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .trim()
  }

  function _showDefaultError (error) {
    $state.go('user.arts')
    console.log({ error })
    ToastService.defaultErrorToast()
  }

  function _createAccountsList (accounts) {
    return accounts.map(account => ({
      ...account,
      label: account.name,
      value: account.id
    }))
  }

  async function _checkSocialMediaIntegrationStatus () {
    const status = $location.search()?.socialMediaStatus
    const isEnableSocialMedia = await $rootScope.getEnableSocialMedia(true)

    if (!status && !isEnableSocialMedia) {
      return
    }

    const types = {
      SUCCESS: api._openSocialMediaLinked,
      ERROR: () => ToastService.showErrorToast($translate.instant('socialMedia.integrationErrorMessage'))
    }

    const showCurrentStatus = types[String(status)]

    if (showCurrentStatus) {
      showCurrentStatus()
    }
  }

  function _openSocialMediaLinked () {
    api.getSocialMediaLinkedController().then(({ SocialMediaLinkedController }) => {
      const socialMediaLinked = UdsModalService.createModal({
        controller: SocialMediaLinkedController,
        modalName: 'socialMediaLinkedDialog'
      })

      socialMediaLinked.open()
    })
  }

  function _isAbleToPublish (templates, isUser, isEnableSocialMedia) {
    return templates.every(template => SocialMediaService.showSocialButton(template, isUser, isEnableSocialMedia))
  }

  function _stripRichText (richText) {
    const sanitized = DOMPurify.sanitize(richText, { ALLOWED_TAGS: [] })
    return sanitized
  }

  function _checkAssetSize (templates) {
    $scope.flags.showWarningSize = false

    function checkSingleAssetSize (template) {
      if (!template?.asset?.size) return

      const assetSizeBytes = parseInt(template.asset.size, 10)
      if (isNaN(assetSizeBytes)) return

      const sizeInMB = SocialMediaService.getMaterialSizeInMB({ size: assetSizeBytes })
      if (sizeInMB > 8) {
        $scope.flags.showWarningSize = true
      }
    }

    templates.forEach(checkSingleAssetSize)
  }

  function _validateMaterials () {
    const materials = $scope.formProperties.materials || []
    const validation = SocialMediaService.validateMaterials(materials)

    $scope.validationState.hasErrors = validation.hasErrors
    $scope.validationState.canContinue = validation.canContinue
  }

  function _handleCaptionOnAddImages (newImages) {
    if (!newImages?.length || isInitialLoad) return

    if (newImages.length > 1) {
      $scope.formProperties.caption = ''
      hasCompanyCaptionValue = false
      return
    }

    const material = newImages[0]
    const isMultiPage = material.isMultiPage || material.pageCount > 1 || material.template?.layers?.length > 1

    if (isMultiPage) {
      api._setCaptionFromMaterial(material)
    }
  }

  function _getMaterialCaption (material) {
    return material.originalMaterial?.details?.suggestions ||
           material.details?.suggestions ||
           material.template?.details?.suggestions || ''
  }

  function _setCaptionFromMaterial (material) {
    const caption = api._getMaterialCaption(material)

    if (caption) {
      $scope.formProperties.caption = api._richTextToPlainText(caption)
      hasCompanyCaptionValue = true
    }
  }
}

export { SocialMediaController }
